export default __webpack_public_path__ + "static/cblogo-8a2d32d6261dbaeadf5dc07a79cf3f36.webp";